import { render, staticRenderFns } from "./AnnouncementForm.vue?vue&type=template&id=6f67a4c6&scoped=true"
import script from "./AnnouncementForm.vue?vue&type=script&lang=js"
export * from "./AnnouncementForm.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementForm.vue?vue&type=style&index=0&id=6f67a4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67a4c6",
  null
  
)

export default component.exports